import { useQuery } from "@apollo/client";
import { PlanName, User } from "../../../gql/graphql";

import { USER_LIST } from "../../../graphql/queries/UserQueries";
import { useUser } from "../../../hooks/user";
import { isAdmin } from "../../../utils/user/isAdmin";
import { InviteUsersForm } from "./InviteUsersForm";
import { UsersSection } from "./UsersSection";
import { FeatureNotSupported } from "./FeatureNotSupported";
import { WithQueryLoader } from "../../shared/WithQueryLoader";

import styles from "./UsersView.module.scss";

export interface InviteFormValues {
  email: string;
}

export const UsersView = () => {
  const { data, loading } = useQuery(USER_LIST);
  const { user } = useUser();

  const isAdminUser = isAdmin(user?.role);

  const renderContent = () => {
    if (user?.organization.subscription?.planName !== PlanName.Teams && !user?.organization.manuallyManagedPlan) {
      return <FeatureNotSupported />;
    }
    return (
      <>
        {isAdminUser && <InviteUsersForm />}
        <UsersSection users={data?.userList as User[]} currentUser={user as User} />
      </>
    );
  };

  return (
    <WithQueryLoader isLoading={loading}>
      <div className={styles.container}>{renderContent()}</div>;
    </WithQueryLoader>
  );
};
